module.exports = __webpack_public_path__ + "static/media/logo.ea7fa8a6.png";